module.exports = __webpack_public_path__ + "img/Distractors_16@2x.fd7d1916.png";